import { render, staticRenderFns } from "./CreateQuotation.vue?vue&type=template&id=4bcd2044&scoped=true"
import script from "./CreateQuotation.vue?vue&type=script&lang=js"
export * from "./CreateQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd2044",
  null
  
)

export default component.exports